import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBluetooth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBluetooth"><Path fillRule="evenodd" clipRule="evenodd" d="M10.0007 1.39868L17.9286 8.00527L13.0462 12L17.9286 15.9947L10.0007 22.6012V14.4917L5.64517 18.0554L4.69531 16.8944L10.0007 12.5536V11.4463L4.69531 7.1055L5.64517 5.94457L10.0007 9.50819V1.39868ZM11.8618 11.0309L11.5007 10.7355V4.60124L15.5728 7.99466L11.8618 11.0309ZM11.8618 12.969L11.5007 13.2645V19.3987L15.5728 16.0053L11.8618 12.969Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBluetooth;
